import { render } from "./PastProjectsList.vue?vue&type=template&id=2d3e8e73"
import script from "./PastProjectsList.vue?vue&type=script&lang=js"
export * from "./PastProjectsList.vue?vue&type=script&lang=js"

import exportComponent from "H:\\Projects\\Jesta\\Front\\Jesta-Group\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__